/**
 * <license header>
 */

import ShippingCarrier from '..';
import WebhookActionResponse from '../../../framework/webhook-action/response';
import { WebhookActionResponseType } from '../../../framework/webhook-action/response/types';

/**
 * Response generator for shipping carriers
 */
class ShippingCarrierResponse {
  private carrier: ShippingCarrier;

  constructor(carrier: ShippingCarrier) {
    this.carrier = carrier;
  }

  /**
   * Generates and returns an array of WebhookActionResponse operations
   *
   * @returns Array of WebhookActionResponse operations
   *
   * @example
   * ```typescript
   * const carrier = new ShippingCarrier('fedex');
   * const response = new ShippingCarrierResponse(carrier);
   * const operations = response.generate();
   * ```
   */
  generate(): WebhookActionResponseType[] {
    const operations: WebhookActionResponseType[] = [];

    // Get added methods from carrier
    const addedMethods = this.carrier['addedMethods'];
    for (const method of addedMethods) {
      operations.push(WebhookActionResponse.add('result', method));
    }

    // Get removed methods from carrier
    const removedMethods = this.carrier['removedMethods'];
    for (const method of removedMethods) {
      operations.push(WebhookActionResponse.add('result', { method: method, remove: true }));
    }

    return operations;
  }
}

export default ShippingCarrierResponse;
